export const FIRST_TWO_HOURS = { id: 'first_two_hours', label: 'Entro le prime due ore dal parto' };
export const TWO_HOURS_LATER = { id: 'two_hours_later', label: 'Dopo le due ore dal parto' };
export const UNDETECTABLE = { id: 'undetectable', label: 'Non rilevabile' };
